import React from 'react';

const VARIANTS = {
  plain: 'bg-white text-gray-900',
  soft: 'bg-[#f4f8f5] text-gray-900',
  accent: 'bg-[#062417] text-white seo-grain',
};

export function SeoSection({ id, variant = 'plain', title, subtitle, children, width = 'max-w-5xl', className = '', testId, sectionRef }) {
  const dark = variant === 'accent';
  return (
    <section id={id} ref={sectionRef} data-testid={testId || (id ? `${id}-section` : undefined)} className={`py-16 sm:py-20 scroll-mt-16 ${VARIANTS[variant]} ${className}`}>
      <div className={`${width} mx-auto px-4 sm:px-6 lg:px-8`}>
        {title && (
          <div className="mb-10 max-w-3xl">
            <h2 className={`font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight ${dark ? 'text-white' : 'text-gray-900'}`}>{title}</h2>
            {subtitle && <p className={`mt-3 text-base md:text-lg ${dark ? 'text-emerald-100/80' : 'text-gray-600'}`}>{subtitle}</p>}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}

export default SeoSection;
